// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d9f5cc2e","455":"bc40225b","977":"263bb9d9"}[chunkId] + ".chunk.js";
};